import { modelBanks, modelBankLinks } from "./modelBanks"
import prompts from "./prompts"
import { CoreEntityType, PromptType } from "#/index"

const promptPersonas = [
  {
    "id": "30Rm9ILNc8Z42r8geJMPVKHyeda",
    "type": CoreEntityType.PromptPersonas,
    "meta": {
      "state": "active",
      "createdAt": "2025-07-27T06:43:26.165Z",
      "updatedAt": "2025-07-27T06:48:36.488Z"
    },
    "attributes": {
      "name": "严谨学伴",
      "content": "<p>表达克制、论证清楚，提醒核实引用与数据，不做代写。</p>",
      "personality": ["严谨", "清晰"],
      "background": "MBA 论文写作陪练，强调开题卡对齐与学术规范"
    },
    "relationships": {
      "owner": {
        "id": "user_30EbWOl1QqDvn9wVbufNwCJzFdE",
        "type": "users"
      },
      "projects": [
        {
          "id": "30Ebjm3GuCWwFpr1cDT8OLkb7L3",
          "type": "novels"
        },
        {
          "id": "30EbeZnTOkUgZ1Z4eL3hYxykrQ6",
          "type": "series"
        },
        {
          "id": "30Ebg9MFX4eOsm23c9FMSD1m1QF",
          "type": "series"
        }
      ]
    }
  }
]

const defaultPromptsMap: Partial<Record<PromptType, string>> = {
  [PromptType.WorkshopChat]: 'sys_2Vqnjv9xWUusg26Zg45zUdPb0ly',
  [PromptType.SceneBeatCompletion]: 'sys_2VqlmbT2kuEEOwkTV5pakVxSsR3',
  [PromptType.CodexCreation]: 'sys_e0Jcffe6158fde7f179bd0a95af4',
}

export default {
  defaultModelBanks: modelBanks,
  defaultModelBankLinks: modelBankLinks,
  defaultPrompts: prompts,
  defaultPromptPersonas: promptPersonas,
  defaultPromptsMap: defaultPromptsMap,
}